export default "__VITE_ASSET__3782855a__"